import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42dc3fc4")

_pushScopeId("data-v-42dc3fc4")
const _hoisted_1 = { class: "alltickets" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("svg", {
    id: "pulse-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "20",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_31",
      "data-name": "Path 31",
      d: "M0,0H24V24H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_32",
      "data-name": "Path 32",
      d: "M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z",
      fill: "#1d2329"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Used tickets ")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "loading_data_spinner"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm mr-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Loading . . . ")
const _hoisted_6 = { class: "card-container" }
const _hoisted_7 = { class: "no-ticket" }
const _hoisted_8 = { class: "dept" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "show_route" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("g", {
      id: "arrow-left-line",
      transform: "translate(24 24) rotate(180)",
      opacity: "0.53"
    }, [
      /*#__PURE__*/_createVNode("path", {
        id: "Path_156",
        "data-name": "Path 156",
        d: "M0,0H24V24H0Z",
        fill: "none"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "Path_157",
        "data-name": "Path 157",
        d: "M3.828,6.778H16v2H3.828l5.364,5.364L7.778,15.556,0,7.778,7.778,0,9.192,1.414Z",
        transform: "translate(4 4.222)",
        fill: "#2c343a"
      })
    ])
  ])
], -1)
const _hoisted_10 = { class: "arr" }
const _hoisted_11 = { class: "bus_company arr" }
const _hoisted_12 = { class: "dept_date" }
const _hoisted_13 = { class: "dept_time" }
const _hoisted_14 = { class: "distance" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "status" }, [
  /*#__PURE__*/_createVNode("p", null, "Expired")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "more" }, [
  /*#__PURE__*/_createVNode("svg", {
    id: "more-2-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_69",
      "data-name": "Path 69",
      d: "M0,0H24V24H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_70",
      "data-name": "Path 70",
      d: "M12,3a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,3Zm0,14a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,17Zm0-7a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z",
      fill: "#1d2329"
    })
  ])
], -1)
const _hoisted_17 = { class: "card_container_mobile" }
const _hoisted_18 = { class: "no-ticket" }
const _hoisted_19 = { class: "tickets_container" }
const _hoisted_20 = { class: "place_time_details" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "time" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("11:30 "),
    /*#__PURE__*/_createVNode("span", null, "AM")
  ]),
  /*#__PURE__*/_createVNode("p", null, "2 hours"),
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("3:30 "),
    /*#__PURE__*/_createVNode("span", null, "PM")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "show_route" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "127",
    viewBox: "0 0 32 127"
  }, [
    /*#__PURE__*/_createVNode("g", {
      id: "Ellipse_35",
      "data-name": "Ellipse 35",
      transform: "translate(1)",
      fill: "none",
      stroke: "#487fff",
      "stroke-width": "3"
    }, [
      /*#__PURE__*/_createVNode("circle", {
        cx: "15",
        cy: "15",
        r: "15",
        stroke: "none"
      }),
      /*#__PURE__*/_createVNode("circle", {
        cx: "15",
        cy: "15",
        r: "13.5",
        fill: "none"
      })
    ]),
    /*#__PURE__*/_createVNode("g", {
      id: "Ellipse_36",
      "data-name": "Ellipse 36",
      transform: "translate(7 6)",
      fill: "none",
      stroke: "#487fff",
      "stroke-width": "3"
    }, [
      /*#__PURE__*/_createVNode("circle", {
        cx: "9",
        cy: "9",
        r: "9",
        stroke: "none"
      }),
      /*#__PURE__*/_createVNode("circle", {
        cx: "9",
        cy: "9",
        r: "7.5",
        fill: "none"
      })
    ]),
    /*#__PURE__*/_createVNode("g", {
      id: "map-pin-line",
      transform: "translate(0 95)"
    }, [
      /*#__PURE__*/_createVNode("path", {
        id: "Path_79",
        "data-name": "Path 79",
        d: "M0,0H32V32H0Z",
        fill: "none"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "Path_80",
        "data-name": "Path 80",
        d: "M16,27.859l7.15-6.773a9.224,9.224,0,0,0,0-13.544,10.514,10.514,0,0,0-14.3,0,9.224,9.224,0,0,0,0,13.544Zm0,3.869L6.808,23.021a11.859,11.859,0,0,1,0-17.414,13.518,13.518,0,0,1,18.385,0,11.859,11.859,0,0,1,0,17.414ZM16,17.05a2.816,2.816,0,0,0,2.889-2.736,2.893,2.893,0,0,0-5.778,0A2.816,2.816,0,0,0,16,17.05Zm0,2.736a5.631,5.631,0,0,1-5.778-5.473A5.631,5.631,0,0,1,16,8.841a5.631,5.631,0,0,1,5.778,5.473A5.631,5.631,0,0,1,16,19.786Z",
        transform: "translate(0 0)",
        fill: "#487fff"
      })
    ]),
    /*#__PURE__*/_createVNode("line", {
      id: "Line_22",
      "data-name": "Line 22",
      y2: "70",
      transform: "translate(15.5 28.5)",
      fill: "none",
      stroke: "#487fff",
      "stroke-width": "3",
      "stroke-dasharray": "10"
    })
  ])
], -1)
const _hoisted_23 = { class: "places" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", null, "RN 345 K", -1)
const _hoisted_25 = { class: "book_now" }
const _hoisted_26 = { class: "more" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "book_now" }, [
  /*#__PURE__*/_createVNode("div", { class: "book_btn" }, [
    /*#__PURE__*/_createVNode("div", { class: "book" }, [
      /*#__PURE__*/_createVNode("a", { href: "" }, "Expired")
    ])
  ])
], -1)
const _hoisted_28 = { class: "price" }
const _hoisted_29 = { class: "price_money" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "RWF", -1)
const _hoisted_31 = { class: "more_details_about_ticket" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "seats" }, [
  /*#__PURE__*/_createVNode("p", null, "Expired status")
], -1)
const _hoisted_33 = { class: "date" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$store.state.Booking.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.para), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.used, (ticket) => {
        return (_openBlock(), _createBlock("div", {
          class: "ticket",
          key: ticket
        }, [
          _createVNode("div", _hoisted_8, [
            _createVNode("p", null, _toDisplayString(ticket.departure), 1)
          ]),
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode("p", null, _toDisplayString(ticket.destination), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("p", null, _toDisplayString(ticket.buscompany), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("p", null, _toDisplayString(ticket.date), 1)
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("p", null, _toDisplayString(ticket.time), 1)
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("p", null, _toDisplayString(ticket.price) + " Frw", 1)
          ]),
          _hoisted_15,
          _hoisted_16
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("p", _hoisted_18, _toDisplayString(_ctx.para), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.used, (tckt) => {
        return (_openBlock(), _createBlock("div", {
          class: "ticket_mobile",
          key: tckt
        }, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _createVNode("h4", null, _toDisplayString(tckt.departure), 1),
                _hoisted_24,
                _createVNode("h4", null, _toDisplayString(tckt.destination), 1)
              ])
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode("p", null, _toDisplayString(tckt.companyname), 1)
              ]),
              _hoisted_27,
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, [
                  _createVNode("p", null, [
                    _createTextVNode(_toDisplayString(tckt.price) + " ", 1),
                    _hoisted_30
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode("div", _hoisted_33, [
              _createVNode("p", null, _toDisplayString(tckt.date), 1)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
})